
import React from 'react';
import { RentalStepProps } from 'rental/app/steps';
import { RentalPageTitleHelmet } from 'rental/components/PageTitleHelmet';
import { ScrollingTermsAndCond } from 'shared/aggreement/ScrollingTermsAndCond';
import { PageContainer } from 'shared/components/PageContainer';
import { PageHeading } from 'shared/components/typography';
import { absPolygonUrl } from 'shared/utils/urls';
import { SubmitActions } from '../../../shared/components/SubmitActions';
import { useAppContext } from '../../app/AppContext';
import { usePortalTermsQuery } from '../../generated.graphql';
import { AgreementCheckboxes } from './AgreementCheckboxes';


interface Props extends RentalStepProps {

}

export const Agreement = (props: Props) => {
  const app = useAppContext();
  const [result,] = usePortalTermsQuery({variables: {portalSlug: app.portalSlug}})

  return (
    <PageContainer>
      <RentalPageTitleHelmet>Rental Agreement</RentalPageTitleHelmet>
      <PageHeading>Review the Rental Agreement</PageHeading>
      <p><em>Please read through and agree to the following Terms &amp; Conditions:</em></p>
      
      <ScrollingTermsAndCond 
        html={result.fetching ? null : result.data?.portal?.policies.terms?.content}
        newWindowLink={absPolygonUrl(`${app.portalSlug}/terms/`, true)}
      />
      
      <div className="p-3">
        <AgreementCheckboxes {...app} />
      </div>
      <SubmitActions
        actions={props.actions}
        submit={() => props.onSubmitSuccessful()}
        disabled={!app.application.acceptedAgreement}
      />
    </PageContainer>
  );
}